
export namespace log {
    export function info(message: string, ...args: any[]) {
        if (console) {
            console.info(`Info: ${message}`, ...args);
        }
    }
    export function warning(message: string, ...args: any[]) {
        if (console) {
            console.error(`Warning: ${message}`, ...args);
        }
    }
}